<template>
    <div class="new-index">
        <RobotSocket ref="robotSocketRef" :nowTime='nowTime' @backSockertData='doSocker($event)' />
        <div class="heard">
            <div class="title-img"><img :src="titleUrl" alt="" /></div>
            <div class="title">智能机器人监控平台</div>
            <div class="title-time">
                <div class="time-ll">
                    {{ newTime.getHours() < 10 ? '0' + newTime.getHours() : newTime.getHours() }}:{{ newTime.getMinutes() < 10 ? '0' + newTime.getMinutes() : newTime.getMinutes() }}:{{ newTime.getSeconds() < 10 ? '0' + newTime.getSeconds() : newTime.getSeconds() }}
                </div>
                <div class="time-li">
                    <div style="text-align: right;">
                        <span v-if="newTime.getDay() === 0">星期日</span>
                        <span v-else-if="newTime.getDay() === 1">星期一</span>
                        <span v-else-if="newTime.getDay() === 2">星期二</span>
                        <span v-else-if="newTime.getDay() === 3">星期三</span>
                        <span v-else-if="newTime.getDay() === 4">星期四</span>
                        <span v-else-if="newTime.getDay() === 5">星期五</span>
                        <span v-else-if="newTime.getDay() === 6">星期六</span>
                    </div>
                    <div style="margin-top: 5px;">
                        {{newTime.getFullYear()}}-{{newTime.getMonth() + 1}}-{{ newTime.getDate() < 10 ? '0' + newTime.getDate() : newTime.getDate() }}
                    </div>
                </div>
            </div>
        </div>

        <div class="content">
            <div class="content-left">
                <div class="content-right-top left-sc-li">
                    <div class="left-li-top">
                        <div class="echarts-div">
                            <div class="eChart-title">实时处理</div>
                            <div class="error-list">
                                <div>时间</div>
                                <div>上报机器</div>
                                <div>上报内容</div>
                                <div>处理状态</div>
                            </div>
                            <div class="error-body">
                                <div v-for="(obj, index) in eventAry" :key="index"
                                    :class="obj.results === '1' ? 'body-li' : 'body-li error-li'">
                                    <div>{{ obj.insDate }}</div>
                                    <div>{{ obj.rName }}</div>
                                    <div class="text">{{ obj.eName }}</div>
                                    <div class="text">{{ obj.resultsName }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="left-li-content"></div>
                    <div class="left-li-bottom"></div>
                </div>
                <div class="content-left-content left-sc-li">
                    <div class="left-li-top">
                        <div class="echarts-div">
                            <div class="eChart-title">事件数据分析</div>
                            <div style="width: 90%;display: inline-block;height: calc(100% - 45px);margin: 0 auto;" id="body-li3">
                            </div>
                        </div>
                    </div>
                    <div class="left-li-content"></div>
                    <div class="left-li-bottom"></div>
                </div>
                <div class="content-left-bottom left-sc-li">
                    <div class="left-li-top">
                        <div class="echarts-div">
                            <div class="eChart-title">事件完成率统计</div>
                            <div style="width: 100%;display: inline-block;height: calc(100% - 45px);" id="echar2-1">
                            </div>
                        </div>
                    </div>
                    <div class="left-li-content"></div>
                    <div class="left-li-bottom"></div>
                </div>
            </div>
            <div class="content-center">
                <div class="center-top corner-border">
                    <div class="left-li-top" style="font-size: 15px;">运行信息</div>
                    <div style="width: 100%;display: inline-block;height: calc(100% - 45px);">
                        <div style="width: 100%;height: 100%;display: inline-block;position: relative;" id="body-li4">
                            <div
                                style="position: absolute;width: 100%;height: 100%;top: 0;left: 0;display: flex;align-items: center;justify-content: center;">
                                <div class="numberli">{{ funReal < 5 ? 0 : parseInt((funNum % 1000000000)/100000000) }}
                                </div>
                                <div class="numberli">{{ parseInt((funNum % 100000000)/10000000) }}</div>
                                <div class="numberli">{{ parseInt((funNum % 10000000)/1000000) }}</div>
                                <div class="numberli">{{ parseInt((funNum % 1000000)/100000) }}</div>
                                <div class="numberli">{{ parseInt((funNum % 100000)/10000) }}</div>
                                <div class="numberli">{{ parseInt((funNum % 10000)/1000) }}</div>
                                <div class="numberli">{{ parseInt((funNum % 1000)/100) }}</div>
                                <div class="numberli">{{ parseInt((funNum % 100)/10) }}</div>
                                <div class="numberli">{{ parseInt(funNum % 10) }}</div>
                            </div>
                        </div>
                        <div style="width: 49%;height: 100%;display: inline-block;" id="body-li4-2">
                        </div>
                        <div
                            style="position: absolute;width: 100%;bottom: 10px;left: 0;text-align: center;color: white;font-size: 18px;font-weight: 600;">
                            运行时长（小时）</div>
                    </div>
                </div>
                <div class="center-bottom corner-border" style="display: block;" ref="adressWrap">
                    <div class="content-div-check"
                        :style="{ width: vWidth + 'px', height: vHeight + 'px', zoom: mapScale}">
                        <img :src="backUrl" />
                        <div class="robot" ref="robot" v-for="(obj, index) in mapRobotAry" :key="index">
                            <div style="white-space: nowrap;">{{ obj.number }}</div>
                        </div>
                    </div>
                    <div class="map-btn">
                        <el-button type="primary" icon="el-icon-sort"
                            style="margin-bottom: 0px;-moz-transform:rotate(-90deg);-webkit-transform:rotate(-90deg);"
                            circle @click="ifMapList=!ifMapList"></el-button>
                        <el-button type="success" icon="el-icon-zoom-in" circle @click="mapScale += 0.1"></el-button>
                        <el-button type="danger" icon="el-icon-zoom-out" circle @click="mapScale -= 0.1"></el-button>
                    </div>

                    <el-button type="info" v-if="mapAry.length > 4 && ifMapList" style="position: absolute;left: 60px;bottom: 60px;padding: 6px;opacity: 0.5;z-index: 99;" circle @click="mapScroll('left')">
                      <i class="el-icon-caret-left" style="font-size: 25px;"></i>
                    </el-button>

                    <el-button type="info" v-if="mapAry.length > 4 && ifMapList" style="position: absolute;right: 60px;bottom: 60px;padding: 6px;opacity: 0.5;z-index: 99;" circle @click="mapScroll('right')">
                      <i class="el-icon-caret-right" style="font-size: 25px;"></i>
                    </el-button>

                    <transition name="el-zoom-in-bottom">
                        <div v-show="ifMapList" class="changeImage">
                            <div class="img-li" v-for="(item, index) in mapAry" :key="index"
                                @click="getMapDetail(index)"
                                :style="{backgroundColor: item.check ? '#2b4490' : 'transparent'}">
                                <div class="img-tltle" style="margin-bottom: 10px;">{{ item.rName }}</div>
                                <el-image style="width: 100px; height: 100px" :src="item.address" fit="scale-down">
                                </el-image>
                            </div>
                        </div>
                    </transition>

                </div>
            </div>
            <div class="content-right">
                <div class="content-left-top right-sc-li">
                    <div class="right-li-top">
                        <div class="echarts-div">
                            <div class="eChart-title">机器人</div>
                            <div style="width: 100%;display: inline-block;height: calc(100% - 45px);">
                                <div style="width: 49%;height: 100%;display: inline-block;" class="robot-body">
                                    <div v-for="(obj, index) in robotAry" :key="index">
                                        <span>{{ obj.robotName }}</span>
                                        <span>{{ obj.routeName }}</span>
                                        <span>{{ obj.onlineStatus === '1' ? obj.ststusName : '离线'}}</span>
                                    </div>
                                </div>
                                <div style="width: 49%;height: 100%;display: inline-block;" id="body-li0">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right-li-content"></div>
                    <div class="right-li-bottom"></div>
                </div>
                <div class="content-right-content right-sc-li">
                    <div class="right-li-top">
                        <div class="echarts-div">
                            <div class="eChart-title">环境信息</div>

                            <div
                                style="width: 90%;display: flex;height: calc((100% - 50px) / 2);justify-content: space-between;align-items: center;border-bottom: 2px solid #02314d;">
                                <div style="display: flex;align-items: center;margin: 0 45px;">
                                  <img :src="temperature" style="width: 50px;margin: 0 20px;">
                                  <span style="font-size: 20px;color: #f9c04e;font-weight: 900;">{{ environObj.temperature }} °C</span>
                                </div>
                                <div style="display: flex;align-items: center;margin: 0 45px;">
                                    <img :src="humidity" style="width: 50px;margin: 0 20px;">
                                    <span style="font-size: 20px;color: rgb(18,150,219);font-weight: 900;">{{ environObj.humidity }} RH</span>
                                </div>
                            </div>
                            <div
                                style="width: 90%;display: flex;height: calc((100% - 50px) / 2);justify-content: space-between;align-items: center;">
                                <div style="display: flex;align-items: center;margin: 0 45px;">

                                  <img v-if="environObj.isSmoke === '0'" :src="noSmoke" style="width: 50px;margin: 0 20px;">
                                  <img v-else :src="smoke" style="width: 50px;margin: 0 20px;" >

                                  <span v-if="environObj.isSmoke === '0'" style="font-size: 20px;color: white;font-weight: 900;">无烟雾</span>
                                  <span v-else style="font-size: 20px;color: #d81e06;font-weight: 900;">有烟雾</span>

                                </div>
                                <div style="display: flex;align-items: center;margin: 0 45px;">
                                    <img :src="pm2_5" style="width: 50px;margin: 0 20px;">
                                    <span style="font-size: 20px;color: #7bbd5f;font-weight: 900;">{{ environObj.pm2_5 }} μg/m³</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="right-li-content"></div>
                    <div class="right-li-bottom"></div>
                </div>
                <div class="content-right-top right-sc-li">
                    <div class="right-li-top">
                        <div class="echarts-div">
                            <div class="eChart-title">语音播放列表</div>

                            <div class="error-list">
                                <div style="width: 33.333%;">播放主题</div>
                                <div style="width: 33.333%;">播放机器</div>
                                <div style="width: 33.333%;">播放时间</div>
                            </div>
                            <div class="error-body">
                                <div v-for="(obj, index) in voiceAry" :key="index" class="body-li">
                                    <div style="width: 33.333%;">{{ obj.voiceName }}</div>
                                    <div style="width: 33.333%;">{{ obj.rName }}</div>
                                    <div style="width: 33.333%;">{{ obj.startTime }}</div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="right-li-content"></div>
                    <div class="right-li-bottom"></div>
                </div>
            </div>
        </div>

    </div>
</template>

<style scoped lang="less"></style>

<script>
    import {
        mapList,
        robotList,
        eventList,
        eventChart,
        positonList,
        rIndex,
        handleTime,
        runTime,
        runMileage
    } from '@/api/index'
    import {
        getItem
    } from '@/utils/auth'
    import {
        todayEventFinish,
        robotVoiceList,
        environInfo
    } from '@/api/customIndex'
    import RobotSocket from '@/components/RobotSocket.vue'
    import '@/page/newIndex/szIndex/index.less'

    export default {
        name: 'newindex',
        components: {
            RobotSocket
        },
        data() {
            return {
                newTime: new Date(),
                nowTime: new Date().getTime(),
                headUrl: require('../../../../static/img/index_head.png'),
                robotSrc: require('../../../../static/img/xyRobot.png'),
                titleUrl: require('../../../../static/img/title.png'),
                error_ul: require('../../../../static/img/error-list.png'),
                error_li: require('../../../../static/img/error-code.png'),
                robot_ul: require('../../../../static/img/robot-ul.png'),
                robot_li: require('../../../../static/img/robot-li.png'),
                pm2_5: require('../../../../static/img/pm2_5.png'),
                temperature: require('../../../../static/img/temperature.png'),
                humidity: require('../../../../static/img/humidity.png'),
                smoke: require('../../../../static/img/smoke.png'),
                noSmoke: require('../../../../static/img/nosmoke.png'),
                backUrl: '',
                mapAry: [],
                robotAry: [],
                mapRobotAry: [],
                mapRobotColor: ['#FF6600', '#FFFF66', '#336699', '#CC6699', '#FF9933', '#FFFFCC', '#009966', '#663300'],
                vWidth: 0,
                vHeight: 0,
                eventAry: [],
                showScrollBtn: false,
                ifMapList: false,
                mapScale: 1,
                funNum: 0,
                funReal: 0,
                checkMap: {},
                voiceAry: [],
                environObj: {
                  pm2_5: 0,
                  temperature: 0,
                  humidity: 0,
                  isSmoke: '0'
                }
            }
        },
        mounted() {
            // 定时执行保持token有效
            let that = this
            setInterval(() => {
                that.newTime = new Date()
            }, 1000)
            setInterval(() => {
                rIndex()
            }, 1000 * 60 * 60 * 5)

            let tenID = getItem('tenantInfoId')
            setTimeout(function() {
                that.eventChart(tenID)
                that.todayEventFinish(tenID)
            }, 500)
            this.mapList(tenID)
            this.robotList(tenID)
            this.eventList(tenID)
            this.handleTime(tenID)
            this.runTime(tenID)
            this.environInfo(tenID)
            this.robotVoiceList(tenID)
        },
        updated() {
            let that = this
            if (that.$refs.robot && that.$refs.robot.length > 0) {
                that.$refs.robot.map((v, index) => {
                    v.style.top = Number(that.mapRobotAry[index].positon.split(',')[1]) - 10 + 'px'
                    v.style.left = Number(that.mapRobotAry[index].positon.split(',')[0]) - 10 + 'px'
                })
            }
        },
        methods: {
            doSocker(socketData) {
                let that = this
                if (socketData.socketType === '1') {
                    if (that.checkMap.number === socketData.map) {
                        let mapRobotList = []
                        that.mapRobotAry.map(v => {
                            mapRobotList.push(v.robotId)
                            if (v.robotId === socketData.robotId) {
                                v.positon = socketData.positon
                            }
                        })
                        if (mapRobotList.indexOf(socketData.robotId) === -1) {
                            that.mapRobotAry.push({
                                area: socketData.area,
                                floor: socketData.floor,
                                map: socketData.map,
                                number: socketData.fromUserId,
                                positon: socketData.positon,
                                robotId: socketData.robotId,
                                ststus: socketData.ststus,
                                ststusName: socketData.ststusName
                            })
                        }
                    }
                    for (let i = 0; i < that.robotAry.length; i++) {
                        if (that.robotAry[i].robotId === socketData.robotId) {
                            that.robotAry[i].ststusName = socketData.ststusName
                        }
                    }
                    that.robotAry = JSON.parse(JSON.stringify(that.robotAry))
                    that.mapRobotAry = JSON.parse(JSON.stringify(that.mapRobotAry))
                } else if (socketData.socketType === '2' || socketData.socketType === '4' || socketData.socketType ===
                    '6' || socketData.socketType === '7') {
                    if (socketData.socketType === '7' && socketData.onlineStatus === '2') {
                        that.mapRobotAry.forEach((v, index) => {
                            if (v.robotId === socketData.robotId) {
                                that.mapRobotAry.splice(index, 1)
                            }
                        })
                        that.mapRobotAry = JSON.parse(JSON.stringify(that.mapRobotAry))
                    }
                    let tenID = getItem('tenantInfoId')
                    that.eventChart(tenID)
                    that.eventList(tenID)
                    that.robotList(tenID)
                }
            },
            mapScroll(type) {
              let leftData = document.getElementsByClassName('changeImage')[0].scrollLeft
              if (type === 'left') {
                document.getElementsByClassName('changeImage')[0].scrollLeft = leftData - 100
              } else {
                document.getElementsByClassName('changeImage')[0].scrollLeft = leftData + 100
              }
            },
            robotVoiceList(id) {
              let that = this
              robotVoiceList(id).then(res => {
                if (res.data) {
                  that.voiceAry = res.data
                }
              })
            },
            todayEventFinish(id) {
              let that = this
              todayEventFinish(id).then(res => {
                if (res.data) {
                  that.Echarts21(res.data)
                }
              })
            },
            environInfo(id) {
              let that = this
              environInfo(id).then(res => {
                  if (res.data) {
                    that.environObj = res.data
                  }
              })
            },
            runTime(id) {
                let that = this
                runTime(id).then(res => {
                    if (res.data && res.data.days) {
                        that.funNum = Number(res.data.days) * 24
                        that.funReal = Number(res.data.days)
                    }
                })
            },
            runMileage(id) {
                let that = this
                runMileage(id).then(res => {
                    that.Echarts4(res.data)
                })
            },
            Echarts21(echarArray) {
              var myChart = this.$echarts.init(document.getElementById('echar2-1'))
              myChart.clear();
              let xData = []
              let yData = []
              echarArray.forEach(res => {
                  xData.push(res.name)
                  yData.push(res.completionRate)
              })
              let option = {
                  xAxis: {
                      type: 'category',
                      data: xData,
                      axisLabel: {
                          rotate: 30,
                          show: true,
                          textStyle: {
                              color: 'rgb(110,112,121)'
                          },
                          fontSize: 14
                      }
                  },
                  yAxis: {
                      type: 'value',
                      axisLabel: {
                          show: true,
                          textStyle: {
                              color: 'rgb(110,112,121)'
                          },
                          fontSize: 14,
                          formatter: '{value}%'
                      }
                  },
                  grid: {
                      top: '10%',
                      left: '2%',
                      bottom: '2%',
                      right: '1%',
                      containLabel: true,
                  },
                  tooltip: {
                      trigger: 'axis',
                      axisPointer: {
                          type: 'cross'
                      },
                      formatter: function(params) {
                          var html = params[0].name + "<br>";
                          for (var i = 0; i < params.length; i++) {
                              html += params[i].marker + '完成率: ' + params[i].value + '%';
                          }
                          return html + "<br>";
                      }
                  },
                  series: [{
                      data: yData,
                      type: 'bar',
                      backgroundStyle: {
                          color: 'rgba(180, 180, 180, 0.2)'
                      },
                      itemStyle: {
                          normal: {
                              color: function(params) {
                                  var colorList = ['rgb(145,204,117)', 'rgb(84,112,198)', '#336699',
                                      '#CC6699',
                                      '#FFFFCC', '#009966', '#663300',
                                      'rgb(145,204,117)', 'rgb(84,112,198)', '#336699',
                                          '#CC6699',
                                          '#FFFFCC', '#009966', '#663300','rgb(145,204,117)', 'rgb(84,112,198)', '#336699',
                                      '#CC6699',
                                      '#FFFFCC', '#009966', '#663300'
                                  ]
                                  return colorList[params.dataIndex]
                              },
                              label: {
                                  show: true,
                                  formatter: '{c}%',
                                  position: 'top',
                                  fontWeight: 600,
                                  fontSize: 15
                              }
                          }
                      }
                  }]
              };
              myChart.setOption(option, true)
            },
            Echarts4(echarArray) {
                var myChart = this.$echarts.init(document.getElementById('body-li4-2'))
                myChart.clear();
                var option = {
                    series: [{
                        radius: '140%',
                        type: 'gauge',
                        startAngle: 180,
                        endAngle: 0,
                        min: 0,
                        max: echarArray.max,
                        splitNumber: echarArray.splitNumber,
                        center: ['50%', '75%'],
                        itemStyle: {
                            color: 'rgb(92,123,198)',
                            shadowColor: 'rgba(0,138,255,0.45)',
                            shadowBlur: 10
                        },
                        progress: {
                            show: true,
                            roundCap: true,
                            width: 10
                        },
                        pointer: {
                            icon: 'path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z',
                            length: '40%',
                            width: 5,
                            offsetCenter: [0, '-20%']
                        },
                        axisTick: {
                            splitNumber: 2,
                            lineStyle: {
                                width: 2,
                                color: '#999'
                            }
                        },
                        axisLine: {
                            roundCap: true,
                            lineStyle: {
                                width: 10,
                                color: [
                                    [240, 'rgb(153,153,153)']
                                ]
                            }
                        },
                        splitLine: {
                            length: 12,
                            lineStyle: {
                                width: 3,
                                color: '#999'
                            }
                        },
                        axisLabel: {
                            distance: 10,
                            color: '#999',
                            fontSize: 12
                        },
                        title: {
                            show: false
                        },
                        detail: {
                            width: '60%',
                            lineHeight: 50,
                            height: 40,
                            offsetCenter: [0, '0%'],
                            valueAnimation: true,
                            formatter: function(value) {
                                return '{value|' + value.toFixed(0) + '}{unit|km}';
                            },
                            rich: {
                                value: {
                                    fontSize: 20,
                                    fontWeight: 'bolder',
                                    color: 'gray'
                                },
                                unit: {
                                    fontSize: 15,
                                    color: '#999'
                                }
                            }
                        },
                        data: [{
                            value: echarArray.splitNumber
                        }]
                    }]
                };
                myChart.setOption(option)
            },
            getMapDetail(index) {
                let that = this
                that.mapAry.map(v => {
                    v.check = false
                })
                that.mapAry[index].check = true
                that.checkMap = that.mapAry[index]
                that.mapAry = JSON.parse(JSON.stringify(that.mapAry))
                that.backUrl = that.mapAry[index].address
                that.vWidth = Number(that.mapAry[index].width)
                that.vHeight = Number(that.mapAry[index].height)
                this.computedScale()
                positonList({
                    number: that.mapAry[index].number,
                    userId: getItem('userInfo').staffId
                }).then(res => {
                    if (res && res.data.length > 0) {
                        that.mapRobotAry = res.data
                    } else {
                        that.mapRobotAry = []
                    }
                })
            },
            eventChart(id) {
                let that = this
                eventChart(id).then(res => {
                    that.Echarts3(res.data)
                })
            },
            eventList(id) {
                let that = this
                eventList(id).then(res => {
                    if (res.data && res.data.length > 0) {
                        that.eventAry = res.data
                    } else {
                        that.eventAry = []
                    }
                })
            },
            handleTime(id) {
                let that = this
                handleTime(id).then(res => {
                    that.Echarts0(res.data)
                })
            },
            robotList(id) {
                let that = this
                robotList(id).then(res => {
                    if (res.data && res.data.length > 0) {
                        that.robotAry = res.data
                    } else {
                        that.robotAry = []
                    }
                })
            },
            mapList(id) {
                let that = this
                mapList(id).then(res => {
                    if (res.data && res.data.length > 0) {
                        that.mapAry = res.data
                        that.mapAry.map(v => {
                            v.check = false
                        })
                        that.backUrl = that.mapAry[0].address
                        that.vWidth = Number(that.mapAry[0].width)
                        that.vHeight = Number(that.mapAry[0].height)
                        that.getMapDetail(0)
                    } else {
                        that.mapAry = []
                    }
                })
            },
            Echarts0(echarArray) {
                var myChart = this.$echarts.init(document.getElementById('body-li0'))
                myChart.clear();
                let datas = [echarArray]
                var option = {
                    title: {
                        show: true,
                        text: '事件处理时效分析',
                        y: 'bottom',
                        x: 'center',
                        textStyle: {
                            color: 'white'
                        }
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b}: {c} ({d}%)'
                    },
                    series: datas.map(function(data, idx) {
                        return {
                            type: 'pie',
                            radius: [30, '60%'],
                            center: ["50%", "45%"],
                            // itemStyle: {
                            //     normal: {
                            //         color(params) {
                            //             var colorList = ['rgb(254,84,84)','rgb(255,192,70)', 'rgb(209,72,254)','rgb(50,186,254)', 'red', 'yellow', 'green'];
                            //             return colorList[params.dataIndex]
                            //         }
                            //     }
                            // },
                            label: {
                                alignTo: 'edge',
                                formatter: '{time|{c}}\n{name|{b}}',
                                edgeDistance: 5,
                                lineHeight: 20,
                                rich: {
                                    time: {
                                        fontSize: 15
                                    },
                                    textStyle: {
                                        color: 'black',
                                    }
                                }
                            },
                            labelLine: {
                                length: 5,
                                length2: 0,
                                maxSurfaceAngle: 80
                            },
                            labelLayout(params) {
                                var isLeft = params.labelRect.x < myChart.getWidth() / 2
                                var points = params.labelLinePoints
                                points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params
                                    .labelRect.width
                                return {
                                    labelLinePoints: points
                                }
                            },
                            data: data
                        }
                    })
                }
                myChart.setOption(option)
            },
            Echarts3(echarArray) {
                var myChart = this.$echarts.init(document.getElementById('body-li3'))
                myChart.clear();
                echarArray.map(v => {
                    v.value = Number(v.number)
                })
                var datas = [echarArray]
                var option = {
                    title: {
                        show: true,
                        text: '当日分析',
                        y: 'bottom',
                        x: 'center',
                        textStyle: {
                            color: 'white'
                        }
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b}: {c} ({d}%)'
                    },
                    series: datas.map(function(data, idx) {
                        return {
                            type: 'pie',
                            radius: [30, '60%'],
                            center: ["50%", "45%"],
                            label: {
                                alignTo: 'edge',
                                formatter: '{time|{c}}\n{name|{b}}',
                                edgeDistance: 5,
                                lineHeight: 20,
                                rich: {
                                    time: {
                                        fontSize: 15
                                    },
                                    textStyle: {
                                        color: 'gray'
                                    }
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: function(params) {
                                        var colorList = ['rgb(145,204,117)', 'rgb(84,112,198)', '#336699',
                                            '#CC6699',
                                            '#FFFFCC', '#009966', '#663300',
                                            'rgb(145,204,117)', 'rgb(84,112,198)', '#336699',
                                                '#CC6699',
                                                '#FFFFCC', '#009966', '#663300','rgb(145,204,117)', 'rgb(84,112,198)', '#336699',
                                            '#CC6699',
                                            '#FFFFCC', '#009966', '#663300'
                                        ]
                                        return colorList[params.dataIndex]
                                    }
                                }
                            },
                            labelLine: {
                                length: 5,
                                length2: 0,
                                maxSurfaceAngle: 80
                            },
                            labelLayout: function(params) {
                                var isLeft = params.labelRect.x < myChart.getWidth() / 2
                                var points = params.labelLinePoints
                                points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params
                                    .labelRect.width
                                return {
                                    labelLinePoints: points
                                }
                            },
                            data: data
                        }
                    })
                }
                myChart.setOption(option)
            },
            computedScale() {
                this.mapScale = 1
                this.$nextTick().then(() => {
                    let oW = this.$refs.adressWrap.offsetWidth
                    let oH = this.$refs.adressWrap.offsetHeight
                    if (this.vWidth != oW || this.vHeight != oH) {
                        let wScale = oW / this.vWidth
                        let hScale = oH / this.vHeight
                        this.mapScale = Math.min(wScale, hScale);
                    }
                })
            }
        },
        watch: {
            newTime: {
                deep: true,
                immediate: true,
                handler(newData, oldData) {
                    let that = this
                    let tenID = getItem('tenantInfoId')
                    if (newData.getMinutes() === 0 && newData.getSeconds() === 0) {
                        that.runTime(tenID)
                        that.handleTime(tenID)
                        that.environInfo(tenID)
                    }
                    if (newData.getHours() === 0 && newData.getMinutes() === 0 && newData.getSeconds() === 0) {
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/page/newIndex/szIndex/index.vue